module.exports = __webpack_public_path__ + "powerUp.222b8e31.gif";


//////////////////
// WEBPACK FOOTER
// ./client/components/powerUp.gif
// module id = 487
// module chunks = 0